import React from 'react'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import { withRouter, RouteComponentProps } from 'react-router'

import {
  Button,
  useAppStyles,
  ErrorMessage as GatoErrorMessage,
} from '@elgatoylacaja/components'

import { Formik } from 'formik'

import { DotsScale } from '@elgatoylacaja/components'

import * as Yup from 'yup'
import StepCounter from '@elgatoylacaja/components/lib/StepCount'
import { AppContext } from '../../contexts/AppContext'
import { Pregunta, calculoFeedbackOcean } from '../../data/ocean'

const from1to5 = Yup.string()
  .oneOf(['1', '2', '3', '4', '5'])
  .required('Este campo es requerido')

const dotLabels = [
  { value: 1, label: 'No estoy de acuerdo' },
  { value: 3, label: 'Ni de acuerdo ni en desacuerdo' },
  { value: 5, label: 'Estoy de acuerdo' },
]

type StepProps = {
  consignas: Pregunta[]
  step: 1 | 2 | 3 | 4
}

const StepTemplate = (props: RouteComponentProps & StepProps) => {
  const appStyles = useAppStyles()

  const {
    dispatch,
    appState: {
      experiment: { paso1, paso2, paso3 },
    },
  } = React.useContext(AppContext)

  const initialValues = React.useMemo(() => {
    return Object.fromEntries(
      props.consignas.map(consigna => [consigna.id, ''])
    )
  }, [props.consignas])

  const ValidationSchema = React.useMemo(() => {
    const objectSchema = Object.fromEntries(
      Object.entries(initialValues).map(([key]) => [key, from1to5])
    )
    return Yup.object(objectSchema)
  }, [initialValues])

  return (
    <>
      <StepCounter colorAll step={props.step - 1} total={4} />
      <Typography variant="h1" className={appStyles.title}>
        Yo me veo a mi mismo/a como alguien...
      </Typography>
      <Formik
        initialValues={initialValues}
        validationSchema={ValidationSchema}
        onSubmit={values => {
          dispatch({
            type: 'SUBMIT_STEP',
            step: props.step,
            values,
          })
          dispatch({
            type: 'SUBMIT_CALCULO',
            values: Object.fromEntries(
              calculoFeedbackOcean({
                ...paso1,
                ...paso2,
                ...paso3,
                ...values,
              })
            ),
          })
          dispatch({ type: 'REGISTER_VISIT', route: `/step-${props.step}` })
        }}
      >
        {({ values, handleSubmit, submitCount, isValid }) => {
          return (
            <form
              onSubmit={handleSubmit}
              id="condiciones-form"
              style={{ marginTop: '40px' }}
            >
              {props.consignas.map(consigna => {
                return (
                  <DotsScale
                    dots={5}
                    id={consigna.id}
                    label={consigna.texto}
                    value={parseInt(values[consigna.id])}
                    dotLabels={dotLabels}
                    key={consigna.id}
                  />
                )
              })}
              <GatoErrorMessage
                condition={submitCount > 0 && !isValid}
                message={'Falta responder alguna consigna'}
              />
            </form>
          )
        }}
      </Formik>
      <Grid className={appStyles.mobileAlignBottom}>
        <Button
          type="submit"
          form="condiciones-form"
          color="primary"
          label="Siguiente"
          aria-label="Siguiente"
        />
      </Grid>
    </>
  )
}

export default withRouter(StepTemplate)
